import {useMutation, useQuery, useQueryClient} from "react-query";
import axios from "axios";
import {PagedSearchParams} from "@atiautomacao/ati-ui-library";
import {useSnackbar} from "notistack";

const apiUrl = "api/teleObjectsSpecificationType";

const fetchTeleObjectSpecificationType = async (pagedSearchParams: PagedSearchParams) => {
    try {
        return await axios
            .get(apiUrl + "/search", {
                params: pagedSearchParams ? pagedSearchParams.toURLSearchParams() : null,
                timeout: 30000
            })
            .then((res) => res.data);
    } catch (error) {
        console.error("Error fetching data:", error);
        return Promise.reject(error);
    }
};

export const TeleObjectSpecificationTypeReactQuery = (pagedSearchParams: PagedSearchParams) => {
    return useQuery({
        queryKey: ["data", pagedSearchParams],
        queryFn: () => {
            return fetchTeleObjectSpecificationType(pagedSearchParams);
        }
    });
};

const saveTeleObjectSpecificationType = async (data: any) => {
    try {
        if(data.id){
            return await axios.put(`${apiUrl}/${data.id}`, data,{timeout:30000}).then((res) => res.data);
        } else {
            return await axios.post(apiUrl, data,{timeout:30000}).then((res) => res.data);
        }
    } catch (error) {
        console.error("Error saving data:", error);
        return Promise.reject(error);
    }
};

export const SaveTeleObjectSpecificationTypeReactQuery = () => {
    const { enqueueSnackbar } = useSnackbar();

    return useMutation({
        mutationFn: (data: any) => {
            return saveTeleObjectSpecificationType(data);
        },
        onSuccess: () => {
            enqueueSnackbar("TeleObjectSpecificationType saved successfully!", { variant: "success" });
        },
        onError: (error: any) => {
            enqueueSnackbar(`Error saving TeleObjectSpecificationType: ${error.message}`, { variant: "error" });
        }
    })
};

const deleteTeleObjectSpecificationType = async (id: number) => {
    try {
        return await axios.delete(`${apiUrl}/${id}`,{timeout:30000}).then((res) => res.data);
    } catch (error) {
        console.error("Error fetching data:", error);
        return Promise.reject(error);
    }
};

export const DeleteTeleObjectSpecificationTypeReactQuery = (pagedSearchParams: PagedSearchParams) => {
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: any) => {
            return deleteTeleObjectSpecificationType(data.id);
        },
        onSuccess: () => {
            enqueueSnackbar("Tipo Específico excluído com sucesso!", { variant: "success" });
            if (pagedSearchParams) {
                queryClient.invalidateQueries(["data", pagedSearchParams]);
            }
        },
        onError: (error: any) => {
            enqueueSnackbar(`Erro ao excluir tipo de equipamento: ${error.message}`, { variant: "error" });
        }
    })
};

const fetchTeleObjectSpecificationTypeById = async (id: number) => {
    try {
        return await axios.get(`${apiUrl}/${id}`,{timeout:30000}).then((res) => res.data);
    } catch (error) {
        console.error("Error fetching data:", error);
        return Promise.reject(error);
    }
};

export const FindTeleObjectSpecificationTypeByIdReactQuery = () => {
    const { enqueueSnackbar } = useSnackbar();
    return useMutation({
        mutationFn: (id: number) => {
            return fetchTeleObjectSpecificationTypeById(id);
        },
        onError: (error: any) => {
            enqueueSnackbar(`Error loading TeleObjectSpecificationType: ${error.message}`, { variant: "error" });
        }
    })
};